import template from './login.pug'

export default Vue.extend({
  template: template(),
  data() {
    return {
      data: {
        email: '',
        password: '',
        twofacode:'',
        method2faAuth:''
      },
      error: false,
      error2fa:false,
      require2faAuth:false,
      method2faAuth:''
    }
  },
  computed: {
    // TODO: cambiar ns-field para que acepte un boolean
    nsFieldErrors() {
      return this.error ? 'error' : ''
    }
  },
  methods: {
    async login() {
      this.errors = []

      if(this.require2faAuth)
      {
        this.data.method2faAuth = this.method2faAuth;
        this.$auth.verify2fa(this.data).then(response => {        
          
          this.$auth.setToken(response.data.token)
          this.$router.push({name: 'analytics-bi-index'})   

        }, response => {
          if (response.status === 422) {
            this.error = this.$t('auth.login.fields.twofacode.errors.invalid2fa')
          }
        })
      }else{

        this.$auth.login(this.data).then(response => {        
          if(response.data.token=="0")
          {
            this.require2faAuth = true;
            this.method2faAuth = response.data.method;
          }
          else{
            this.$auth.setToken(response.data.token)
            this.$router.push({name: 'analytics-bi-index'})
          }        
        }, response => {
          if (response.status === 422) {
            const emailError = response.data.tokenErrors.email
  
            // no queremos mostrar los errores de campo obligatorio, solo estos dos
            if (emailError && emailError.error === 'unconfirmed') {
              this.error = this.$t('auth.login.fields.email.errors.unconfirmed')
            } else {
              this.error = this.$t('auth.login.fields.password.errors.invalid')
            }
          }
        })

      }

   
    }
  }
})
